import React from 'react';
import { priceFormat } from '../../../../util';
import * as toolSelectors from '../../../../selectors/tools';
import { useSelector } from 'react-redux';
import { getItemNameAndQuantity } from '../helpers';
import { ResultsColumn, ResultsColumnHeader, Row, HeaderRow, SubTitleText, Spreadsheet } from '../DTInfoWidget.styles';

const DTToBeRefundedItemDetailsWidget = () => {
  const returnedItems = useSelector(toolSelectors.getReturnedItems);
  const orderingSystem = useSelector(toolSelectors.getOrderingSystem);

  if (returnedItems.length) {
    return (
      <Spreadsheet className="fs-block">
        <SubTitleText>ITEMS TO BE REFUNDED</SubTitleText>
        <HeaderRow>
          <ResultsColumnHeader>ITEM</ResultsColumnHeader>
          <ResultsColumnHeader>PRICE</ResultsColumnHeader>
        </HeaderRow>
        {returnedItems.map((item) => (
          <Row key={JSON.stringify(item)} className="fs-block">
            <ResultsColumn>{getItemNameAndQuantity(item, orderingSystem)}</ResultsColumn>
            <ResultsColumn>{priceFormat(item.price)}</ResultsColumn>
          </Row>
        ))}
      </Spreadsheet>
    );
  }

  return null;
};
export default DTToBeRefundedItemDetailsWidget;
